import React from 'react';
import { Hammer, DollarSign, TrendingUp, ShieldCheck, Smartphone } from 'lucide-react';
export function AchievementsSection() {
  const achievements = [{
    icon: <Hammer className="w-8 h-8 text-amber-500" data-id="element-17" />,
    text: 'Aplicar pisos epoxi correctamente desde el inicio'
  }, {
    icon: <DollarSign className="w-8 h-8 text-green-500" data-id="element-18" />,
    text: 'Cotizar con seguridad y margen real'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-amber-400" data-id="element-19" />,
    text: 'Convertirlo en un emprendimiento rentable'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-red-500" data-id="element-20" />,
    text: 'Reducir prueba/error y pérdidas de material'
  }, {
    icon: <Smartphone className="w-8 h-8 text-amber-300" data-id="element-21" />,
    text: 'Tener un sistema para conseguir clientes'
  }];
  return <section className="py-16 px-4 bg-[#111]" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-white flex items-center justify-center gap-3" data-id="element-24">
          <span data-id="element-25">📦</span> ¿Qué vas a lograr?
        </h2>

        <div className="grid gap-6" data-id="element-26">
          {achievements.map((item, index) => <div key={index} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800 flex items-center gap-6 hover:border-amber-800/50 transition-colors" data-id="element-27">
              <div className="bg-[#222] p-3 rounded-full flex-shrink-0" data-id="element-28">
                {item.icon}
              </div>
              <p className="text-lg md:text-xl font-semibold text-gray-200" data-id="element-29">
                {item.text}
              </p>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-30">
          <p className="text-2xl md:text-4xl font-black text-white uppercase" data-id="element-31">
            El objetivo no es aprender. <br data-id="element-32" />
            <span className="text-amber-500 bg-amber-900/20 px-2" data-id="element-33">
              Es cobrar.
            </span>
          </p>
        </div>
      </div>
    </section>;
}